import React from 'react';

import { Grid, InputAdornment } from '@material-ui/core';
import { TextField, SwitchField, Step } from '../SteppedForm';
import rules from './rules';

const StepCabsureDetails = (props) => {
  return (
    <Step
      id="cabsure_details"
      title="Cabsure Quote Recipient Details"
      skip={() => !props.getVehicle().requested_cabsure_insurance_quote}
      key={'CabsureDetails-' + props.getVehicle().Cabsure_UseDetails}>
      <Grid container>
        <Grid item xs={12} lg={12} style={{ marginBottom: '15px' }}>
          <SwitchField id="Cabsure_UseDetails" label="Use applicants details" color="secondary" />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            id="Cabsure_Firstname"
            label="First Name"
            suppressOptional
            value={
              props.getVehicle().Cabsure_UseDetails
                ? props.state.formdata.applicants[0].firstname
                : props.getVehicle().Cabsure_Firstname
            }
            disabled={props.getVehicle().Cabsure_UseDetails}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="Cabsure_Surname"
            label="Surname"
            suppressOptional
            value={
              props.getVehicle().Cabsure_UseDetails
                ? props.state.formdata.applicants[0].surname
                : props.getVehicle().Cabsure_Surname
            }
            disabled={props.getVehicle().Cabsure_UseDetails}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="Cabsure_Email"
            label="Email Address"
            suppressOptional
            value={
              props.getVehicle().Cabsure_UseDetails
                ? props.state.formdata.applicants[0].email
                : props.getVehicle().Cabsure_Email
            }
            valid={props.getVehicle().Cabsure_UseDetails ? { valid: () => true } : rules.email}
            disabled={props.getVehicle().Cabsure_UseDetails}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="Cabsure_Mobile"
            label="Mobile Phone"
            suppressOptional
            value={
              props.getVehicle().Cabsure_UseDetails
                ? props.state.formdata.applicants[0].mobile
                : props.getVehicle().Cabsure_Mobile
            }
            valid={props.getVehicle().Cabsure_UseDetails ? { valid: () => true } : rules.phone}
            disabled={props.getVehicle().Cabsure_UseDetails}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            id="Cabsure_M7AccountNo"
            label="M7 Account Number"
            value={
              props.getVehicle().Cabsure_UseDetails ? props.state.formdata.m7_account || '' : ''
            }
            valid={rules.numeric}
            modify={(value) => props.limitLength(value, 5)}
            InputProps={{
              startAdornment: <InputAdornment position="start">A</InputAdornment>
            }}
            disabled={props.getVehicle().Cabsure_UseDetails}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField id="Cabsure_Odometer" label="Vehicle Odometer Read" valid={rules.numeric} />
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField id="Cabsure_Taxi_Registration_Number" label="Taxi Registration number"/>
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepCabsureDetails;
